import { render, staticRenderFns } from "./ProofreadingEditor.vue?vue&type=template&id=3edb433d&scoped=true"
import script from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
export * from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingEditor.vue?vue&type=style&index=0&id=3edb433d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb433d",
  null
  
)

export default component.exports